import React from "react";

/**
 * A horizontal separator line that separate different sections in the UI.
 */
export const Separator: React.FC = () => {
    return (
        <hr className="separator-line" />
    )
}